import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from '../../shared/base/base.component';
import { MatomoTracker } from 'ngx-matomo';
import { LayoutComponent} from'src/app/layout/layout.component';
@Component({
  selector: 'app-wmsm-StatementQuery',
  templateUrl: './wmsm-StatementQuery.component.html',
  styleUrls: ['./wmsm-StatementQuery.component.scss']
})
export class WmsmStatementQueryComponent extends BaseComponent implements OnInit {
  loading: boolean = false;
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  listOfData: any[] = [];
  validateForm: FormGroup;
  formValues: any;
  monthFormat = 'yyyy/MM';

  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private Environment: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private LayoutComponent:LayoutComponent,
  ) { super() }

  ngOnInit() {
    this.validateForm = this.fb.group({
      PONO: [''],
      Rno: [''],
      StatementMonthFrom: [''],
      StatementMonthTo: [''],
      InvoiceNo: [''],
      BillingStatus: [''],
    });
    this.LayoutComponent.geturl()
    this.matomotracker.trackPageView("供應商管理")
    this.matomotracker.trackEvent("供應商管理","CN對賬單查询","view",1);
  }
  getFormValue(value) {
    this.formValues = value;
  }

  getQuery(value) {

  }
  onSearch() {
    this.getResultData()
  }
  // 获取查询表格数据
  getResultData() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.QueryRtStatement.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        Buyer:this.formValues.Buyer,
        SiteNo:this.formValues.Site,
        PoNo: this.formValues.PONO,
        PaNo: this.formValues.PANo,
        Rno: this.formValues.RNO,
        StatementMonthFrom: this.getTheDateString_(this.formValues.StatementMonth[0]),
        StatementMonthTo: this.getTheDateString_(this.formValues.StatementMonth[1]),
        Invoice: this.formValues.InvoiceNo,
        WithdrawStatus:  this.formValues.BillingStatus,
        VendorCode:this.formValues.Vendor
      },
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (
          res &&
          res.status == this.Environment.authConfig.wmsmStatus
        ) {
          this.listOfData = res.data.map((item) => {
            item.statementMonth = this.getTheDateString_YM(item.statementMonth);
            item.acDate = DateUtil.formatYMD(item.acDate);
            return item;
          });
          this.nzTotal = res.total;
          this.NzMessageService.success(res.msg);
        } else {
          this.listOfData = [];
          this.nzTotal = 0;
          this.NzMessageService.warning(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.loading = false;
      }
    );
  }
  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }
  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }

  exportTableToExecl() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownLoadRtStatementExcel.url}`;
    const params = {
      data: {
        Buyer:this.formValues.Buyer,
        SiteNo:this.formValues.Site,
        PoNo: this.formValues.PONO,
        PaNo: this.formValues.PANo,
        Rno: this.formValues.RNO,
        StatementMonthFrom: this.getTheDateString_(this.formValues.StatementMonth[0]),
        StatementMonthTo: this.getTheDateString_(this.formValues.StatementMonth[1]),
        Invoice: this.formValues.InvoiceNo,
        WithdrawStatus:  this.formValues.BillingStatus,
        VendorCode:this.formValues.Vendor
      },
    };
    this.WebApiService.doPost(url, params, true).subscribe((res) => {
      this.downloadFile8(res, `CHN_Payment_Inquiry_${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }


  onQueryClick():string {
    return 'StatementQuery';
  }


  sortChange(e) {
    this.listOfData = e === 'ascend' ? this.listOfData.sort(
      (a, b) => a.poNo.localeCompare(b.poNo)
    ) : this.listOfData.sort(
      (a, b) => b.poNo.localeCompare(a.poNo)
    )
  }
}
